<iframe #iframe [src]="url | safeUrl"  (load)="loadEvent($event)" width="100%" height="100%" frameborder="0"></iframe>